import { createSlice } from '@reduxjs/toolkit';

import resetStore from '../resetStore';

// export const setCommentThunk = createAsyncThunk(
//   'stock/setComment',
//   async (params, { rejectWithValue }) => {
//     try {
//       const res = await setComment(params);
//       return res;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.message || 'Не удалось добавить комментарий'
//       );
//     }
//   }
// );

const initialState = {
  stocks: [],
  selectedStocks: [],
  currentPage: 1,
  totalPages: 0,
  totalItems: 0,
  itemsPerPage: 6,
  fetchStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  fetchError: null,
  storageCount: 0, // количество элементов для вкладки "Хранение"
  returnsCount: 0, // количество элементов для вкладки "Возвраты"
  orderedCount: 0,
  step: 0,
  passStep: 0,
  selectImg: '',
};

const stocksSlice = createSlice({
  name: 'stocks',
  initialState,
  reducers: {
    setImg(state, action) {
      state.selectImg = action.payload;
    },
    setPassStep(state, action) {
      state.passStep = action.payload;
    },
    addStep(state) {
      state.step += 1;
      console.log(state.step);
    },
    removeStep(state) {
      state.step -= 1;
      console.log(state.step, 'remove step');
    },
    clearStep(state) {
      state.step = 0;
    },
    setStepRed(state, action) {
      state.step = action.payload;
    },
    setStocks(state, action) {
      // ВАЖНО: раньше было
      //   state.stocks = action.payload.stocks || action.payload || [];
      // Если в ответе нет ключа stocks (или он null/пустой), то `||`
      // подставлял САМ ОБЪЕКТ ответа, и в state.stocks оказывался объект
      // вместо массива. Дальше [...stocksFromStore] в StocksList падал с
      // "TypeError: y is not iterable" и ронял всю страницу /refund через
      // ErrorBoundary. Проверка на массив это исключает.
      const { payload } = action;
      if (Array.isArray(payload?.stocks)) {
        state.stocks = payload.stocks;
      } else if (Array.isArray(payload)) {
        state.stocks = payload;
      } else {
        state.stocks = [];
      }
      state.totalPages = payload?.total_pages || 0;
      state.totalItems = payload?.total_count || 0;
      state.currentPage = payload?.current_page || 1;
    },
    pushStocks(state, action) {
      console.log(action.payload, 'action.payload in pushStocks');
      state.stocks = [...state.stocks, action.payload.newElement];
      console.log(state.stocks, 'stocks after pushStocks');
    },
    replaceStocks(state, action) {
      // та же защита: в state.stocks должен попадать только массив
      state.stocks = Array.isArray(action.payload) ? action.payload : [];
    },
    appendStocks(state, action) {
      // Подгрузка следующей страницы: добавляем только карточки, которых ещё нет в списке
      // (при добавлении вещей на складе между запросами граница страниц может сдвинуться).
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      const keyOf = (s) => `${s.grm}|${s.date}|${s.status}`;
      const known = new Set(state.stocks.map(keyOf));
      incoming.forEach((item) => {
        const key = keyOf(item);
        if (!known.has(key)) {
          known.add(key);
          state.stocks.push(item);
        }
      });
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setItemsPerPage(state, action) {
      state.itemsPerPage = action.payload;
    },
    setFetchStatus(state, action) {
      state.fetchStatus = action.payload;
    },
    setFetchError(state, action) {
      state.fetchError = action.payload;
    },
    setStorageCount(state, action) {
      console.log(action.payload);
      state.storageCount = action.payload.total_count;
    },
    setOrderedCount(state, action) {
      state.orderedCount = action.payload.total_count;
    },
    setReturnsCount(state, action) {
      console.log(action.payload);
      state.returnsCount = action.payload.total_count;
    },
    updateComment(state, action) {
      const { grm, comment } = action.payload;

      // Находим нужный stock по grm
      const stock = state.stocks.find((s) => s.grm === grm);

      if (stock) {
        stock.comment = comment; // Обновляем комментарий
      }
    },
    toggleSelected(state, action) {
      const id = action.payload.grm;
      console.log(
        state.selectedStocks,
        'selectedStocks',
        action.payload,
        'action.payload'
      );
      if (state.selectedStocks.some((el) => el.grm === id)) {
        state.selectedStocks = state.selectedStocks.filter(
          (stockId) => stockId.grm !== id
        );
        // defaultStock.qty += 1;
      } else {
        // action.payload.qty = 1;
        // defaultStock.qty = 0;
        state.selectedStocks.push(action.payload);
      }
    },
    plusQty(state, action) {
      const stock = state.selectedStocks.find((el) => el.grm === action.payload);
      if (stock) {
        stock.qty += 1;
        // defaultStock.qty -= 1;
      }
      console.log(stock.qty);
    },
    minusQty(state, action) {
      const stock = state.selectedStocks.find((el) => el.grm === action.payload);
      if (stock) {
        stock.qty -= 1;
        // defaultStock.qty += 1;
      }
    },
    setQtyBySelectedStock(state, action) {
      const stock = state.selectedStocks.find((el) => el.grm === action.payload.grm);
      if (stock) stock.qty = action.payload.qty;
    },
    clearSelected(state) {
      console.log('work clearSelected');
      state.selectedStocks = [];
    },
    selectAll(state) {
      const allStocks = state.stocks.map((stock) => stock);
      state.selectedStocks = allStocks;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
  },
});

export const {
  appendStocks,
  setStocks,
  setCurrentPage,
  setItemsPerPage,
  setFetchStatus,
  setFetchError,
  setStorageCount,
  setReturnsCount,
  toggleSelected,
  clearSelected,
  selectAll,
  pushStocks,
  addStep,
  removeStep,
  clearStep,
  setStepRed,
  setImg,
  plusQty,
  minusQty,
  updateComment,
  setOrderedCount,
  setQtyBySelectedStock,
  replaceStocks,
} = stocksSlice.actions;
export default stocksSlice.reducer;
